export default __webpack_public_path__ + "login1.jpg";